import { produce } from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { fetchFeaturesApi } from '../../services/feature';
import { AgentTypes } from '../../types/agent.type';

export const storeName = 'featureEntity';

export const featureEntity = createModel<RootModel>()({
  name: storeName,
  state: { codes: {} },
  reducers: {
    ...baseEntity,
    saveIds: produce((state, entities) => {
      (entities || []).forEach((entity: AgentTypes) => {
        state.ids[entity.id] = entity;
      });
    }),
  },
  effects: (dispatch: RematchDispatch<typeof featureEntity>) => ({
    async fetchAllFeature() {
      const resp = await fetchFeaturesApi();
      if (!resp) return null;
      const { data } = resp;

      this.saves(data.content);
      return resp;
    },
  }),
});

export default featureEntity;
